// extracted by mini-css-extract-plugin
export var close = "header-module--close--85H9G";
export var darkTheme = "header-module--darkTheme--3exdN";
export var deviceMobile = "header-module--deviceMobile--SjGnh";
export var fastPayment = "header-module--fastPayment--f416i";
export var header = "header-module--header--Zms1V";
export var icon = "header-module--icon--JPvyr";
export var linkList = "header-module--link-list--LZ3J3";
export var logo = "header-module--logo--mTLiM";
export var menu = "header-module--menu--Tzp5Z";
export var overlayPosition = "header-module--overlayPosition--UYr-i";
export var stateOpen = "header-module--stateOpen--xokGB";